<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { useChatStore } from '../stores/chatStore';

const props = defineProps<{
  isShow: boolean,
  pages: Array<MessageDataPage>,
  language: string,
  historyId?: string
}>();

const { messages } = useI18n()
const config = useRuntimeConfig();
const chatStore = useChatStore();

const sendRelatedInfoClick = async (page: MessageDataPage, isTranslated: boolean) => {
  if (!config.public.relatedInfoClicksApi) {
    return;
  }

  try {
    await $fetch(config.public.relatedInfoClicksApi, {
      method: 'POST',
      body: {
        session_id: chatStore.sessionId || undefined,
        history_id: props.historyId || undefined,
        page_id: page.id,
        page_no: page.no,
        url: page.url,
        language: props.language,
        is_translated: isTranslated,
      },
      keepalive: true,
    });
  } catch (error) {
    console.error('関連情報クリック送信エラー', error);
  }
};

const handleClick = (page: MessageDataPage, isTranslated = false) => {
  sendRelatedInfoClick(page, isTranslated);
};
</script>

<template>
  <div v-if="props.isShow" :class="chatStore.createLanguageClass(props.language)">
    <p class="font-bold my-5 mb-5 text-base">{{ messages[language.replace("-", "")]["relatedInfo"] }}：</p>
    <p v-if="language != 'ja'" class="text-sm mb-5">{{ messages[language.replace("-",
      "")]["relatedSupplement"] }}</p>

    <div class="flex flex-col gap-5">
      <div class=" min-w-[240px] w-fit text-sm" v-for="page in props.pages" :key="page.no">
        <a :href="page.url" class="flex items-center border font-lang-ja border-design-red rounded-sm bg-design-pink"
          @click="handleClick(page)"
          target="_blank">
          <div class="bg-design-pink px-2">{{ page.no }}</div>
          <div class="bg-white text-start p-1 grow hover:bg-design-pink">{{ page.title }}</div>
        </a>
        <a v-if="language != 'ja'"
          :href="config.public.googleTranslateUrl + '?sl=ja&tl=' + chatStore.language + '&hl=ja&u=' + page.url"
          @click="handleClick(page, true)"
          class="flex items-center outline outline-1 outline-design-red rounded-sm bg-design-pink mt-2" target="_blank">
          <div class="bg-design-pink px-2">{{ page.no }}</div>
          <div class="bg-white text-start p-1 grow hover:bg-design-pink">{{ page.translate_title }}</div>
        </a>
      </div>
    </div>
  </div>
</template>
